import React from 'react';
import * as Sentry from '@sentry/react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    console.error('UI error:', error, info);
    // Ship to Sentry with the React component stack as additional context.
    // No-op in dev (Sentry init skips localhost).
    Sentry.captureException(error, {
      contexts: { react: { componentStack: info?.componentStack } },
    });
    if (error?.message?.includes('dynamically imported module') || error?.message?.includes('Failed to fetch')) {
      window.location.reload();
    }
  }
  render() {
    if (this.state.error) {
      return (
        <div className="shell">
          <h2 style={{ color: 'var(--danger)' }}>Something broke</h2>
          <pre style={{ whiteSpace: 'pre-wrap', background: 'var(--bg-elev)', padding: 12, borderRadius: 8, fontSize: 12 }}>
            {String(this.state.error?.stack || this.state.error?.message || this.state.error)}
          </pre>
          <button onClick={() => this.setState({ error: null })}>Try again</button>
          <button onClick={() => location.reload()} style={{ marginLeft: 8 }}>Reload</button>
        </div>
      );
    }
    return this.props.children;
  }
}
